<template lang="pug">
.history-card(v-if="products && products.length > 0")
  h3(v-if="title") {{ title }}
  table.history-table
    thead
      tr
        th Producto
        th Talla
        th Cantidad
        th Motivo
        th Valor
    tbody
      tr(v-for="(item, index) in products" :key="index")
        td.td-product(@click="openProduct(item.product)")
          img.product-thumb(v-if="productImageSrc(item)" :src="productImageSrc(item)" :alt="item.product")
          span.product-link {{ item.product }}
        td {{ item.size || '—' }}
        td {{ item.quantity }}
        td {{ changeReasonMap[item.reason] || item.reason }}
        td {{ money(item.value) }}
</template>

<script>
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlChangeReason from '@/graphql/changeReason'
import config from '@/config'

export default {
  name: 'ProductsTable',

  mixins: [mFilters],

  props: {
    products: Array,
    brand: String,
    title: {
      type: String,
      default: 'Productos'
    }
  },

  data () {
    return {
      imagePath: config.IMAGES.path,
      changeReasons: []
    }
  },

  async created () {
    const response = await gql.query(gqlChangeReason.GET_ALL, {})
    if (response) this.changeReasons = response.data.getChangeReasons
  },

  computed: {
    changeReasonMap () {
      return this.changeReasons.reduce((map, r) => { map[r.index] = r.reason; return map }, {})
    }
  },

  methods: {
    openProduct (product) {
      const { href } = this.$router.resolve(`/products?product=${product}`)
      window.open(href, '_blank')
    },

    productImageSrc (item) {
      if (!item.image) return null
      const gender = this.brand === 'sahet' ? 'man' : 'woman'
      return `${this.imagePath}/${this.brand}/products/${gender}/${item.image}`
    }
  }
}
</script>

<style lang="stylus">
.history-card
  background white
  border-radius 1em
  padding 2.5em
  margin-bottom 1.5em

.history-table
  width 100%
  border-collapse collapse
  font-size 1.05em
  thead tr
    border-bottom 2px solid #f0f0f0
  th
    text-align center
    padding 0.6em 1em
    color #888
    font-weight 600
    font-size 0.9em
    text-transform uppercase
    letter-spacing 0.04em
  td
    padding 0.9em 1em
    color #1a1a1a
    border-bottom 1px solid #f0f0f0
    vertical-align middle
  tbody tr:last-child td
    border-bottom none
  td:first-child
    display flex
    align-items center
    gap 0.5em
    font-weight 600
  td:first-child .material-symbols-outlined
    font-size 1.2em
    color #888

.td-product
  display flex
  align-items center
  gap 0.8em
  cursor pointer
  &:hover .product-link
    text-decoration underline

.product-link
  color inherit

.product-thumb
  width 5rem
  height 5rem
  object-fit cover
  border-radius 0.4em
  flex-shrink 0
</style>



// WEBPACK FOOTER //
// src/components/elements/ProductsTable.vue